import BaseController from "controllers/base"

class Controller extends BaseController {
  call() {
    super.call()

    console.log("External Account Controller")
  }
};

export default Controller;
